// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { stringMustBeNumber } from 'validators/common/simple'

// must be a number and must be min <= x <= max
const stringMustBeWithinRange = (v, min, max, unit = '') => (
  stringMustBeNumber(v) ||
  (
    (+v < min && `Value cannot be less than ${min}${unit}`) ||
    (+v > max && `Value cannot be greater than ${max}${unit}`)
  )
)

export default stringMustBeWithinRange
